// src/shared/components/common/error-state.tsx

import { AlertCircle } from 'lucide-react'
import type { ReactNode } from 'react'

import { Button } from '@/shared/components/ui/button'
import { Card } from '@/shared/components/ui/card'

interface ErrorStateProps {
  title?: string
  description?: string
  onRetry?: () => void
  retryLabel?: string
  action?: ReactNode
}

export function ErrorState({
  title = 'Не удалось загрузить',
  description = 'Что-то пошло не так. Попробуйте обновить.',
  onRetry,
  retryLabel = 'Повторить',
  action,
}: ErrorStateProps) {
  return (
    <Card padding="lg">
      <div className="flex flex-col items-start gap-3">
        <span className="flex h-10 w-10 items-center justify-center rounded-md bg-[var(--color-danger-bg)] text-[var(--color-danger-fg)]">
          <AlertCircle className="h-5 w-5" />
        </span>
        <h3 className="font-display text-base font-semibold text-[var(--color-text)]">{title}</h3>
        <p className="max-w-lg text-sm text-[var(--color-text-soft)]">{description}</p>
        {onRetry || action ? (
          <div className="flex gap-2">
            {onRetry ? (
              <Button onClick={onRetry} size="sm" variant="secondary">
                {retryLabel}
              </Button>
            ) : null}
            {action}
          </div>
        ) : null}
      </div>
    </Card>
  )
}
